import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import StopIcon from '@mui/icons-material/Stop';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, CircularProgress, IconButton } from '@mui/material';
import { getFile } from '../../api/bot';

const Play = <PlayArrowIcon color="secondary" fontSize="large" />;
const Stop = <StopIcon fontSize="large" />;
const Alert = <PriorityHighIcon color="error" fontSize="large" />;

const Player = (props) => {
  const { diary, id, sx, setPlaying, playing, error, setError } = props;
  const [icon, setIcon] = useState(Play);
  const [progress, setProgress] = useState(0);

  const controlPlay = () => {
    if (!playing) setPlaying(id);
    if (playing === id) setPlaying(false);
  };

  const onPlay = () => {
    setIcon(Stop);
    setPlaying(id);
  };

  const onProgress = (data) => {
    const { playedSeconds, loadedSeconds } = data;
    const val = Math.round((playedSeconds / loadedSeconds) * 100);
    if (data.played === 1 || (playing && playedSeconds === 0)) {
      setIcon(Play);
      setPlaying(false);
      setTimeout(() => {
        setProgress(0);
      }, 500);
    } else {
      setProgress(val >= 99 ? 100 : val);
    }
    // if (data.played === 1) {
    //   setIcon(Play);
    //   setPlaying(false);
    // } else if (data.played > 0) {
    //   setProgress(Math.round(data.played * 100));
    // }
  };

  const onPause = () => {
    if (progress < 86) {
      setIcon(Play);
    }
  };

  const onError = () => {
    setError('해당 음성일기 파일을 정상적으로 로드할 수 없습니다.');
    if (progress < 86) {
      setIcon(Alert);
    }
  };

  useEffect(() => {
    if (!playing) {
      setProgress(0);
    }
  }, [playing]);

  return (
    <Box sx={{ ...sx }}>
      <ReactPlayer
        url={getFile({ diary })}
        style={{ display: 'none' }}
        config={{
          file: {
            forceAudio: true,
          },
        }}
        width={0}
        volume={1}
        {...{
          playing: playing === id,
          onError,
          onPlay,
          onProgress,
          onPause,
        }}
      />

      <Box sx={{ position: 'relative' }}>
        <CircularProgress
          variant="determinate"
          value={playing === id ? progress : 100}
          color={playing === id ? 'secondary' : 'grey'}
          sx={{
            opacity: `${playing === id ? 1 : 0.4}`,
            width: '50px !important',
            height: '50px !important',
          }}
        />
        <IconButton
          aria-label="play&pause"
          onClick={!error ? controlPlay : () => {}}
          sx={{ position: 'absolute', top: '1px', left: '1px' }}
        >
          {icon}
        </IconButton>
      </Box>
    </Box>
  );
};

export default Player;
